// PointsList.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import EditPointModal from './EditPointModal';
import AddPointModal from './AddPointModal';
import DeleteConfirmModal from '../DeleteConfirmModal';
import ViewPointModal from './ViewPointModal';
import MapView from './MapView';
import '../../style/PointsList.css';

const PointsList = () => {
    const [points, setPoints] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [selectedPoint, setSelectedPoint] = useState(null);
    const [activeTab, setActiveTab] = useState('list'); // State for navbar

    useEffect(() => {
        axios.get('https://api.alertapp.kz/api/v1/points')
            .then(response => setPoints(response.data))
            .catch(error => console.error('Error fetching points:', error));
    }, []);

    const handleEditClick = (point) => {
        setSelectedPoint(point);
        setIsEditModalOpen(true);
    };

    const handleViewClick = (point) => {
        setSelectedPoint(point);
        setIsViewModalOpen(true);
    };

    const handleDeleteClick = (point) => {
        setSelectedPoint(point);
        setIsDeleteModalOpen(true);
    };

    const handleDelete = () => {
        axios.delete(`https://api.alertapp.kz/api/v1/points/${selectedPoint._id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            }
        })
            .then(() => {
                setPoints(points.filter(p => p._id !== selectedPoint._id));
                setIsDeleteModalOpen(false);
            })
            .catch(error => console.error('Error deleting point:', error));
    };

    const handleUpdate = (updatedPoint) => {
        setPoints(points.map(p => p._id === updatedPoint._id ? updatedPoint : p));
        setIsEditModalOpen(false);
    };

    const handleAdd = (newPoint) => {
        setPoints([...points, newPoint]);
        setIsAddModalOpen(false);
    };

    return (
        <div className="points-container">
            {/* Navbar */}
            <div className="navbar">
                <button
                    className={activeTab === 'list' ? 'active' : ''}
                    onClick={() => setActiveTab('list')}
                >
                    Список
                </button>
                <button
                    className={activeTab === 'map' ? 'active' : ''}
                    onClick={() => setActiveTab('map')}
                >
                    Карта
                </button>
            </div>

            {/* Conditional Rendering Based on Active Tab */}
            {activeTab === 'list' ? (
                <div className="points-table-container">
                    <table className="points-table">
                        <thead>
                        <tr>
                            <th>Название</th>
                            <th>Адрес</th>
                            <th>Телефон</th>
                            <th>Действия</th>
                        </tr>
                        </thead>
                        <tbody>
                        {points.map((point) => (
                            <tr key={point._id}>
                                <td>{point.name}</td>
                                <td>{point.address}</td>
                                <td>{point.phone}</td>
                                <td>
                                    <button className="view-button" onClick={() => handleViewClick(point)}>Детали</button>
                                    <button className="edit-button" onClick={() => handleEditClick(point)}>Редактировать</button>
                                    <button className="delete-button" onClick={() => handleDeleteClick(point)}>Удалить</button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <button className="add-button" onClick={() => setIsAddModalOpen(true)}>
                        Добавить новую точку
                    </button>
                </div>
            ) : (
                <div className="map-view-container">
                    <MapView points={points} />
                </div>
            )}

            {/* Modals */}
            {isEditModalOpen && (
                <EditPointModal
                    point={selectedPoint}
                    onClose={() => setIsEditModalOpen(false)}
                    onUpdate={handleUpdate}
                />
            )}
            {isAddModalOpen && (
                <AddPointModal
                    onClose={() => setIsAddModalOpen(false)}
                    onAdd={handleAdd}
                />
            )}
            {isDeleteModalOpen && (
                <DeleteConfirmModal
                    point={selectedPoint}
                    onClose={() => setIsDeleteModalOpen(false)}
                    onConfirm={handleDelete}
                />
            )}
            {isViewModalOpen && (
                <ViewPointModal
                    point={selectedPoint}
                    onClose={() => setIsViewModalOpen(false)}
                />
            )}
        </div>
    );
};

export default PointsList;
